import { CLIENT_ORG_CONTEXT_ENUM } from '@provider-directory/types/organizations.contracts';
import { FlyoutMenuLink } from '../../montefiore/header/header-secondary-menu';
import { UtilityLink } from '../../montefiore/header/header-utility-menu';

export const MEAC_ORG_KEY = CLIENT_ORG_CONTEXT_ENUM.enum.montefiore_meac;

export const buildMEACFlyoutHeadline = (
  companyUrl: string,
): FlyoutMenuLink => ({
  text: 'meac.brandName',
  link: { href: companyUrl },
  showIcon: false,
});

export const MEACFlyoutHeadlineSubtitle = 'meac.regionTagline';

export const buildMEACFlyoutMenu = (companyUrl: string): FlyoutMenuLink[] => [
  {
    text: 'montefiore.careAndServices',
    link: { href: `${companyUrl}/services` },
    showIcon: true,
  },
  {
    text: 'montefiore.locations',
    link: { href: `${companyUrl}/locations` },
    showIcon: true,
  },
  {
    text: 'montefiore.patientResources',
    link: { href: `${companyUrl}/patient-resources` },
    showIcon: true,
  },
];

export const MEACUtilityRightMenu: UtilityLink[] = [
  {
    text: 'montefiore.makeAnAppointment',
    link: {
      href: 'https://montefioreeinsteinadvancedcare.org/appointments',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.mychart',
    link: {
      href: 'https://montefioreeinsteinadvancedcare.org/patient-resources/managing-your-care/mychart',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.payBill',
    link: {
      href: 'https://montefioreeinsteinadvancedcare.org/patient-resources/billing-insurance/pay-your-bill',
      target: '_blank',
    },
  },
  {
    text: 'montefiore.forProfessionals',
    link: {
      href: 'https://montefioreeinsteinadvancedcare.org/for-professionals',
      target: '_blank',
    },
  },
];
